import script from "./RateBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RateBar.vue?vue&type=script&setup=true&lang=ts"

import "./RateBar.vue?vue&type=style&index=0&id=efcf09f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efcf09f8"]])

export default __exports__